import { Component, AfterViewInit, HostListener } from '@angular/core';
import { gsap } from 'gsap';

enum infoOpen {
  none = 0,
  nobble = 1,
  clergy = 2,
  knights = 3,
  oligarchy = 4,
  plebs = 5
}

@Component({
    selector: 'app-social-order',
    templateUrl: './social-order.component.html',
    styleUrls: ['./social-order.component.css'],
})

export class SocialOrderComponent implements AfterViewInit {

  constructor() {
    
  }
  info: infoOpen = 0;
  scrollRAF: number | undefined;
  scrollTime = 4000;

  ngAfterViewInit(): void {

    if (!this.ShowParalax())
      return;

    gsap.timeline({ scrollTrigger: { trigger: '.scrolltop', start: 'center center', toggleActions: "play none none none", onLeave: self => self.endAnimation(), onLeaveBack: self => self.endAnimation() } })
      .to(".Brave", { duration: 2, text: "Are you brave enough to<br>challenge the established order?", ease: "linear" })

    const tlEffect01 = this.createEffect01();
    const tlEffect02 = this.createEffect02();
    const cloudAnim = gsap.to(".cloud2", {
      duration: 360,
      ease: "none",
      x: "+=2500",
      modifiers: {
        x: gsap.utils.unitize(x => parseFloat(x) % 2500)
      },
      repeat: -1
    });


    const targets = document.querySelectorAll(".scrollDist");
    
    const options = {
      threshold: 0.1  //10% height is visible, observer should be triggered
    }

    const callback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          cloudAnim.play();
          if(tlEffect01)
            tlEffect01.play();
          if (tlEffect02)
            tlEffect02.play();
        } else {
          cloudAnim.pause(0);
          if (tlEffect01)
            tlEffect01.pause(0);
          if (tlEffect02)
            tlEffect02.pause(0);
        }
      });
    }
    const observer = new IntersectionObserver(callback, options);
    targets.forEach(target => observer.observe(target));
    
    gsap.timeline({
      scrollTrigger: {
        trigger: '.scrollDist', start: 'top center-=600', end: 'bottom bottom+=50', scrub: 0}
    })
      .fromTo('.sky', { y: -20, scale: "+=0.025", x: -22, autoAlpha: 1.5 }, { y: 150, scale: "-=0.025", x: 0, autoAlpha: 0.3 }, 0)
      .fromTo('.layer7', { y: -20, x: -2, scale: "+=0.012" }, { y: 120, x: 0, scale: "-=0.012" }, 0)
      .fromTo('.layer6', { y: 0 }, { y: 120 }, 0)
      .fromTo('.layer3', { y: -10 }, { y: 70 }, 0)
      .fromTo('.layer2', { y: -150 }, { y: 120 }, 0)
      .fromTo('.layer1', { y: -250 }, { y: 150 }, 0)
  }

  @HostListener("wheel", ["$event"])
  public onScroll(event: WheelEvent) {
    this.stopScroll();
  }

  stopScroll() {
    if (this.scrollRAF) {
      cancelAnimationFrame(this.scrollRAF);
      this.scrollRAF = undefined;
    }
  }

  private smoothScrollTo(startY: number, targetY: number, duration: number) {
    this.stopScroll();
    const startTime = performance.now();

    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeProgress = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, startY + (targetY - startY) * easeProgress);
      if (progress < 1) {
        this.scrollRAF = requestAnimationFrame(animate);
      } else {
        this.scrollRAF = undefined;
      }
    };
    this.scrollRAF = requestAnimationFrame(animate);
  }

  ScrollTo(dist) {
    const startY = window.scrollY;
    this.smoothScrollTo(startY, startY + dist, this.scrollTime);
  }

  createEffect01() {
    return gsap.timeline({ repeat: -1, delay:0.2 })
      .to(".layer4",
        {
          y: "-=4",
          duration: 2,
          ease: "sine.inOut"
        }
      )
      .to(".layer4",
        {
          y: "+=4",
          duration: 2,
          ease: "sine.inOut"
        }
      );
  }
  createEffect02() {
    return gsap.timeline({ repeat: -1, delay: 0.2 })
      .to(".layer5",
        {
          y: "+=10",
          duration: 3,
          ease: "sine.inOut"
        }
      )
      .to(".layer5",
        {
          y: "-=10",
          duration: 3,
          ease: "sine.inOut"
        }
      );
  }

  NobilityMouseEnter() {
    gsap.fromTo('.RectFN', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
  }
  NobilityMouseLeave() {
    gsap.fromTo('.RectFN', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
  }
  ClergyMouseEnter() {
    gsap.fromTo('.RectFC', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
  }
  ClergyMouseLeave() {
    gsap.fromTo('.RectFC', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
  }
  GuardiansMouseEnter() {
    gsap.fromTo('.RectFG', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
  }
  GuardiansMouseLeave() {
    gsap.fromTo('.RectFG', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
  }
  OligarchyMouseEnter() {
    gsap.fromTo('.RectFO', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
  }
  OligarchyMouseLeave() {
    gsap.fromTo('.RectFO', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
  }
  PlebeiansMouseEnter() {
    gsap.fromTo('.RectFP', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
  }
  PlebeiansMouseLeave() {
    gsap.fromTo('.RectFP', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
  }

  closeAllPaper() {
    this.stopScroll();
    if (this.info == 1) {
      gsap.fromTo('.paper1', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
      gsap.fromTo('.scroll1', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
    }
    if (this.info == 2) {
      gsap.fromTo('.paper2', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
      gsap.fromTo('.scroll2', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
    }
    if (this.info == 3) {
      gsap.fromTo('.paper3', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
      gsap.fromTo('.scroll3', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
    }
    if (this.info == 4) {
      gsap.fromTo('.paper4', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
      gsap.fromTo('.scroll4', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
    }
    if (this.info == 5) {
      gsap.fromTo('.paper5', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
      gsap.fromTo('.scroll5', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
    }
    this.info = 0;
  }

  triggerAnim1() {
    if (this.info != 1) {
      this.closeAllPaper();
      this.ScrollTo(document.querySelector(".scrollDist")!.getBoundingClientRect().top);
      gsap.fromTo('.paper1', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
      gsap.fromTo('.scroll1', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
      this.info = 1;
    }
    else {
      this.closeAllPaper();
      this.info = 0;
    }
  }

  triggerAnim2() {
    if (this.info != 2) {
      this.closeAllPaper();
      this.ScrollTo(document.querySelector(".scrollDist")!.getBoundingClientRect().top + this.GetHeight() * .20);
      gsap.fromTo('.paper2', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
      gsap.fromTo('.scroll2', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
      this.info = 2;
    }
    else {
      this.closeAllPaper();
      this.info = 0;
    }
  }

  triggerAnim3() {
    if (this.info != 3) {
      this.closeAllPaper();
      this.ScrollTo(document.querySelector(".scrollDist")!.getBoundingClientRect().top + this.GetHeight() * .30);
      gsap.fromTo('.paper3', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
      gsap.fromTo('.scroll3', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
      this.info = 3;
    }
    else {
      this.closeAllPaper();
      this.info = 0;
    }
  }

  triggerAnim4() {
    if (this.info != 4) {
      this.closeAllPaper();
      this.ScrollTo(document.querySelector(".scrollDist")!.getBoundingClientRect().top + this.GetHeight() * .45);
      gsap.fromTo('.paper4', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
      gsap.fromTo('.scroll4', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
      this.info = 4;
    }
    else {
      this.closeAllPaper();
      this.info = 0;
    }
  }

  triggerAnim5() {

    if (this.info != 5) {
      this.closeAllPaper();
      this.ScrollTo(document.querySelector(".scrollDist")!.getBoundingClientRect().top + this.GetHeight() * .52);
      gsap.fromTo('.paper5', 0.25, { autoAlpha: 0 }, { autoAlpha: 1 });
      gsap.fromTo('.scroll5', 0.25, { autoAlpha: 1 }, { autoAlpha: 0 });
      this.info = 5;
    }
    else {
      this.closeAllPaper();
      this.info = 0;
    }
  }

  scrollDown() {
    this.closeAllPaper();
    this.ScrollTo(document.querySelector(".scrollDist")!.getBoundingClientRect().top + this.GetHeight() * .52);
  }

  GetHeight(): number {
    const target = document.querySelector(".scrollDist")
    return target!.scrollHeight;
  }

  ShowParalax() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width > 1200) {
      return true;
    } else {
      return false;
    }
  }
}
